module.exports = __webpack_public_path__ + "img/blueMail.a03b438c.svg";